import React from 'react';
import mobilierImage from '../../images/mobilier.JPG';
import CategoryPage from '../CategoryPage';

function MobilierPage() {
    const details = [
        'Louis XV (1730-1770)',
        'Louis XVI (1770-1790)',
        'Empire (1804-1815)',
        'Rococo (1730-1760)',
        'Art Déco (1920-1939)',
        'Biedermeier (1815-1848)',
        'Arts and Crafts (1860-1910)',
        'Mission (1890-1910)',
        'Victorien (1837-1901)',
        'Art Nouveau (1890-1910)',
        'Mid-Century Modern (1945-1965)',
        'Minimalisme (1970-présent)',
        'Shaker (1780-1860)',
        'Scandinave (1950-présent)',
        'Baroque (1600-1750)',
        'Renaissance (1400-1600)',
        'Gothique (1100-1500)',
        'Chippendale (1755-1790)',
        'French Provincial (1700-1800)',
        'Industrial (1900-présent)',
        'Meubles Chinois Traditionnels (1644-1912)',
        'Meubles Japonais Traditionnels (Heian: 794-1185, Edo: 1603-1868)',
        'Meubles Coréens Traditionnels (1392-1897)',
        'Meubles Thaïlandais (Sukhothai: 1238-1438, Ayutthaya: 1350-1767)',
        'Meubles Indiens Traditionnels (1526-1857)',
    ];

    const description = `
        Antiquaire chevronné, je suis constamment à la recherche de meubles anciens, authentiques et de qualité, couvrant une variété de styles et d’époques. Passionné par l’histoire et le raffinement des objets, je m’intéresse particulièrement aux pièces uniques, en bon état, qui portent l’empreinte du temps. Si vous détenez des meubles anciens d’exception, n’hésitez pas à me contacter pour discuter d’une possible acquisition.

        Secrétaire - Meuble Dodane - Meuble marqueterie - Table - Commode - Bibliothèque ou Vitrine - Fauteuil ou Bergère - Buffet ou Vaisselier - Chaise - Meuble de salon - Console, etc.
    `;

    return (
        <CategoryPage
            title="Mobilier"
            image={mobilierImage}
            description={description}
            details={details}
        />
    );
}

export default MobilierPage;
